import { z } from "zod";

export const SignUpSchema = z
  .object({
    email: z.email({ message: "Ungültige E-Mail-Adresse." }),
    password: z
      .string({ message: "Passwort ist erforderlich." })
      .min(8, { message: "Passwort muss mindestens 8 Zeichen lang sein." })
      .max(100, { message: "Passwort darf höchstens 100 Zeichen lang sein." }),
    passwordRepeat: z.string({
      message: "Bitte wiederholen Sie Ihr Passwort.",
    }),
  })
  .refine((data) => data.password === data.passwordRepeat, {
    message: "Passwörter stimmen nicht überein.",
    path: ["passwordRepeat"],
  });

export type SignUpSchema = z.infer<typeof SignUpSchema>;

export const SignInSchema = z.object({
  email: z.string().min(1, "E-Mail ist erforderlich")
    .refine((val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val), {
      message: "Ungültige E-Mail-Adresse",
    }),
  password: z
    .string({ message: "Passwort ist erforderlich." })
    .min(8, { message: "Passwort muss mindestens 8 Zeichen lang sein." }),
});

export type SignInSchema = z.infer<typeof SignInSchema>;

export const ForgotPasswordSchema = z.object({
  email: z.string().min(1, "E-Mail ist erforderlich")
    .refine((val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val), {
      message: "Ungültige E-Mail-Adresse",
    }),
});

export type ForgotPasswordSchema = z.infer<typeof ForgotPasswordSchema>;

export const ResetPasswordSchema = z
  .object({
    password: z
      .string({ message: "Passwort ist erforderlich." })
      .min(8, { message: "Passwort muss mindestens 8 Zeichen lang sein." })
      .max(100, { message: "Passwort darf höchstens 100 Zeichen lang sein." }),
    passwordRepeat: z.string({ message: "Bitte wiederholen Sie Ihr Passwort." }),
  })
  .refine((data) => data.password === data.passwordRepeat, {
    message: "Passwörter stimmen nicht überein.",
    path: ["passwordRepeat"],
  });

export type ResetPasswordSchema = z.infer<typeof ResetPasswordSchema>;

export const ChangePasswordSchema = z
  .object({
    password: z.string({ message: "Aktuelles Passwort ist erforderlich." }),
    newPassword: z.string({ message: "Passwort ist erforderlich." }),
    passwordRepeat: z.string({ message: "Bitte wiederholen Sie Ihr Passwort." }),
  })
  .refine((data) => data.newPassword === data.passwordRepeat, {
    message: "Passwörter stimmen nicht überein.",
    path: ["passwordRepeat"],
  });

export type ChangePasswordSchema = z.infer<typeof ChangePasswordSchema>;

export const UpdateUserSchema = z.object({
  firstName: z.string().min(1, "Vorname ist erforderlich"),
  lastName: z.string().min(1, "Nachname ist erforderlich"),
  company: z.string(),
  salutation: z.union([
    z.literal("frau"),
    z.literal("herr"),
    z.literal("divers"),
  ]),
  // telephone: z.string().min(1, "Telefonnummer ist erforderlich"),
  telephone: z.string().optional(),
  preferredLanguage: z.string().min(1, "Sprache ist erforderlich"),
});

export type UpdateUserSchema = z.infer<typeof UpdateUserSchema>;

export const NotificationSettingsSchema = z.object({
  emailNotification: z.boolean(),
  desktopNotification: z.boolean(),
  mobilePushNotification: z.boolean(),
  newLocationsInMyCity: z.boolean(),
  frequency: z.enum(["weekly", "monthly"]),
});

export type NotificationSettingsSchema = z.infer<typeof NotificationSettingsSchema>;
